import { useEffect, type FunctionComponent } from "react";
import ProposalSocialTable from "../../../components/proposal-social-table.components";
import Spinner from "../../../components/spinner.components";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import { Link, useParams } from "react-router-dom";
import { useGetProposalSocialsAdminHttp } from "../../../hooks/http/admin/proposal-creators/get-proposal-socials.admin.http";
import useProposalSocialStore from "../../../store/proposal-creators.store";
import { Button } from "../../../components/ui/button";
import FilterIcon from "../../../assets/svgs/common/filter.svg";
import BoostIcon from "../../../assets/svgs/common/boost.svg";

export const CreatorListProposalsAdminPartial: FunctionComponent = () => {
  const { setData: setSocials, data: socials } = useProposalSocialStore();

  const { execute: getProposalSocialsHttp, fetching: fetchingProposalSocials } =
    useGetProposalSocialsAdminHttp();

  const { toast } = useToast();
  const { proposalId } = useParams();

  async function getProposalSocials() {
    if (!proposalId) {
      return;
    }
    const response = await getProposalSocialsHttp({
      body: null,
      pathParams: { proposalId },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    setSocials(response.data.campaignProposalSocials);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (proposalId) {
      getProposalSocials();
    }
  }, []);
  return (
    <div className="flex flex-col flex-1 justify-between w-full h-full">
      <div className="flex flex-col flex-1 justify-center items-center px-6 w-full h-full">
        {fetchingProposalSocials ? (
          <div className="flex justify-center items-center w-full h-96">
            <Spinner />
          </div>
        ) : (
          <div className="flex flex-col gap-8 py-10 pb-20 w-full">
            <ProposalSocialTable
              fetchingSocials={fetchingProposalSocials}
              data={socials || []}
            />
          </div>
        )}
      </div>

      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div
        id="getProposalSocialsAdmin"
        onClick={() => {
          getProposalSocials();
        }}
        className="hidden"
      />
      <div className="right-0 bottom-0 z-10 fixed bg-sidemenubg border-t border-border w-full">
        <div className="flex justify-end items-center gap-5 px-10 py-5 w-full">
          {proposalId ? (
            <Button
              onClick={() => {
                navigator.clipboard.writeText(
                  `${window.location.origin}/brands/proposal/${proposalId}`
                );
                toast({
                  content: "Proposal Link Copied",
                  toastType: "success",
                });
              }}
              className="bg-soloboost px-6 py-6 font-semibold text-sm"
            >
              <BoostIcon className="pr-2 w-6 h-6" />
              Share Proposal
            </Button>
          ) : null}
          {proposalId ? (
            <Link
              to={`/admin/proposals/proposal/${proposalId}/creator-list/manage-filters`}
            >
              <Button className="flex items-center gap-1 bg-tertiorybuttonbg px-8 py-6 border border-border font-semibold">
                <FilterIcon />
                Manage filters
              </Button>
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};
